import React, { useState, useEffect } from "react";

const Gallery = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getImages`)
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        setImages(res.imgs);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const showImage = (e) => {
    document.getElementById("ax").src = e.target.src;
  };

  return (
    <div>
      <div
        className={`m-4 grid grid-cols-6 gap-6
        screen1200:grid-cols-5
        screen1000:grid-cols-4
        screen700:grid-cols-3
        screen370:grid-cols-2
        screen700:gap-2
        screen1000:gap-3
      
      `}
      >
        {images?.map((img, index) => {
          // console.log("iii", img.images.split("\\")[1], img.id);
          return (
            <div
              key={img.id}
              className=" w-[80%]  rounded-2xl overflow-hidden shadow-md shadow-[#ecec3975]
              screen700:w-[90%]
              "
            >
              <img
                className="w-full h-[140px] 
                screen500:h-[100px]
                "
                alt="عکس گالری صرافی روبین"
                title="عکس گالری صرافی روبین"
                onClick={(e) => showImage(e)}
                src={
                  `${process.env.REACT_APP_URL}/images/` +
                  img.images.split("\\")[1]
                }
              />
            </div>
          );
        })}
      </div>
      {images[0]?.images.split("\\")[1] ? (
        <img
          className="my-8 w-3/4 h-[500px] mx-auto rounded-2xl shadow-md shadow-zinc-400
        screen900:h-[400px]
        screen600:h-[270px]
        screen600:w-[90%]
        screen500:h-[220px]
        "
          alt="عکس گالری صرافی روبین"
          title="عکس گالری صرافی روبین"
          src={
            `${process.env.REACT_APP_URL}/images/` +
            images[0]?.images.split("\\")[1]
          }
        />
      ) : (
        <div
          style={{ direction: "rtl" }}
          className="text-center my-10 h-52 screen700:h-64 screen700:my-20  text-white font-bold text-sm"
        >
          گالری خالی است ...
        </div>
      )}
    </div>
  );
};

export default Gallery;
